import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import Papa from 'papaparse';
import { useListasModel } from '../../modelos/listas/modeloListas';
import { useTutoresModel } from '../../modelos/Tutores/modeloTutores';
import { useNavigate } from 'react-router-dom'; // Importamos useNavigate
//import { documentosOptions, formacionOptions } from './../../config/constants';
import { useFormOptions } from '../../config/constants';

const Formulario = () => {
  const navigate = useNavigate();
  const { documentosOptions, formacionOptions } = useFormOptions();

  // cargue de datos indiivdual
  const {
    // universidades
    universidadesOptions,
    isLoadingUniversidad,
    erroruniversidades,
    cargarUniversidades,
    // carreras
    carrerasOptions,
    isLoadingCarreras,
    errorCarreras,
    cargarCarreras,
    //paises
    paises,
    isLoadingpaises,
    errorpaises,
    cargarPaises,
    //ciudades
    ciudades,
    isLoadingciudades,
    errorciudades,
    cargarCiudades
  } = useListasModel();
  const {
    nuevoTutor,
    handleChange,
    addNewProspectoTutor,
    formularioEnviado,
  } = useTutoresModel();

  useEffect(() => {

    const cargarDatos = async() =>{
      console.log("cagando cosas");
      cargarUniversidades();
      console.log("Estado de carga actualizado:", isLoadingCarreras);
      cargarCiudades();
      cargarCarreras();
      cargarPaises();
    }

    cargarDatos();
  
  }, []);

  // Función para obtener el objeto de opción a partir del valor
  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  const envioFormulario = (e) => {
    e.preventDefault();
    addNewProspectoTutor(nuevoTutor);
  };

  if(formularioEnviado) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <div className="max-w-2xl w-full mx-4 my-6 bg-white rounded-lg shadow-md overflow-hidden">
          {/* Header con logo - mismo estilo que el formulario */}
          <div className="bg-green-500 text-white p-4 flex justify-between items-center">
            <div className="text-xl">∑ ÷ ∞</div>
            <h1 className="text-4xl font-bold">EduSmart</h1>
            <div className="text-xl">🎓 📚</div>
          </div>
          
          {/* Mensaje de éxito */}
          <div className="p-6">
            <h2 className="text-xl font-bold text-green-600 mb-2">Aplicación enviada</h2>
            <p className="text-sm text-gray-600 mb-6">Tu solicitud ha sido procesada correctamente</p>
            
            <div className="flex flex-col items-center justify-center py-8">
              <div className="bg-green-100 rounded-full p-4 mb-6">
                <svg className="w-16 h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-800 mb-4">¡Gracias por tu aplicación!</h3>
              <p className="text-gray-600 mb-8 text-center">
                Tu información ha sido recibida correctamente.<br/>
                Para completar tu perfil, por favor inicia sesión.
              </p>
              
              <button 
                onClick={() => navigate('/login')} 
                className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-8 rounded-full transition-colors duration-300 w-full sm:w-auto"
              >
                Iniciar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="max-w-2xl w-full mx-4 my-6 bg-white rounded-lg shadow-md overflow-hidden">
        {/* Header con logo */}
        <div className="bg-blue-500 text-white p-4 flex justify-between items-center">
          <div className="text-xl">∑ ÷ ∞</div>
          <h1 className="text-4xl font-bold">EduSmart</h1>
          <div className="text-xl">🎓 📚</div>
        </div>

      
      
        {/* Formulario */}
        <div className="p-6">
          <h2 className="text-xl font-bold text-blue-600">Aplicar a tutor</h2>
          <p className="text-sm text-gray-600 mb-6">Complete todos los campos solicitados a continuación</p>

          <form onSubmit={envioFormulario} 
            className="space-y-4" 
            autoComplete="none"
            spellCheck="false" // Helps prevent some browsers from trying to be "helpful"
            >
            {/* Nombre completo */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Nombre completo: 
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                name="nombreCompleto"
                value={nuevoTutor.nombreCompleto}
                onChange={handleChange}
                placeholder="Coloque su nombre completo, ej: Andres Fernando Ramirez Sanchez"
                className="p-2 border border-gray-300 rounded w-full"
                required
                />
              </div>

            {/* Número de WhatsApp */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Número de WhatsApp (debe empezar por 57):
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                name="numeroWhatsapp"
                value={nuevoTutor.numeroWhatsapp}
                onChange={handleChange}
                placeholder="(Colóquelo sin espacio o puntos, después del 57) ej:573161384420"
                className={`p-2 border ${
                      nuevoTutor.numeroWhatsapp && nuevoTutor.numeroWhatsapp.length > 0
                        ? nuevoTutor.numeroWhatsapp.startsWith('57') && nuevoTutor.numeroWhatsapp.length >= 10
                          ? "border-green-300"
                          : "border-red-300"
                        : "border-gray-300"
                    } rounded w-full`}                
                required
                inputMode="numeric"
                pattern="[0-9]*"
                minLength="12"
                maxLength="12"
              />
            </div>

            {/* Tipo de Documento */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Tipo de Documento:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <Select
                name="tipoDocumento"
                value={getOptionFromValue(documentosOptions, nuevoTutor.tipoDocumento)}
                onChange={(option) => handleChange(null, { ...option, name: 'tipoDocumento' })}
                options={documentosOptions}
                placeholder="Selecciona tu tipo de documento"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
              />
            </div>

            {/* Número de documento */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Numero de documento:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                name="identificacionTutor"
                value={nuevoTutor.identificacionTutor}
                onChange={handleChange}
                placeholder="Ingrese el número de documento ej: 1008427435"
                className="p-2 border border-gray-300 rounded w-full"
                required
              />
            </div>

            {/* Correo Electrónico */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Correo Electrónico:
                <span className="text-red-500 ml-1">*</span>
                </label>
              <input
                type="email"
                name="correogmail"
                value={nuevoTutor.correogmail}
                onChange={handleChange}
                placeholder="Ingrese su correo electrónico ej: dufyasesorias@gmail.com"
                className="p-2 border border-gray-300 rounded w-full"
                required
                autoComplete="email"
              />
            </div>

            {/* Formación académica */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Formación académica:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <Select
                name="formacionAcademica"
                value={getOptionFromValue(formacionOptions, nuevoTutor.formacionAcademica)}
                onChange={(option) => handleChange(null, { ...option, name: 'formacionAcademica' })}
                options={formacionOptions}
                placeholder="Seleccione su formación académica, ej: Estudiante pregrado"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
                  />
              </div>

            {/* Carrera */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Carrera (Si tu carrera no esta, por favor avisanos para agregarla):
                <span className="text-red-500 ml-1">*</span>
              </label>
              <Select
                name="carrera"
                value={getOptionFromValue(carrerasOptions, nuevoTutor.carrera)}
                onChange={(option) => handleChange(null, { ...option, name: 'carrera' })}
                options={carrerasOptions}
                placeholder="Seleccione su carrera ej: Ingeniería civil"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
                isLoading={isLoadingCarreras} // Agregar estado de carga
                isDisabled={isLoadingCarreras || errorCarreras} // Deshabilitar durante carga o error
              />
            </div>

            {/* Universidad */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Universidad (Si tu Universidad no esta, por favor avisanos para agregarla):
                <span className="text-red-500 ml-1">*</span>
              </label>
              <Select
                name="universidad"
                value={getOptionFromValue(universidadesOptions, nuevoTutor.universidad)}
                onChange={(option) => handleChange(null, { ...option, name: 'universidad' })}
                options={universidadesOptions}
                placeholder={isLoadingUniversidad ? "Cargando universidades..." : "Selecciona una universidad"}
                isClearable
                isSearchable
                className="mb-4"
                required
                isLoading={isLoadingUniversidad} // Agregar estado de carga
                isDisabled={isLoadingUniversidad || erroruniversidades} // Deshabilitar durante carga o error
              />
            </div>

            {/* País de origen */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                País de origen:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <Select
                name="paisOrigen"
                value={getOptionFromValue(paises, nuevoTutor.paisOrigen)}
                onChange={(option) => handleChange(null, { ...option, name: 'paisOrigen' })}
                options={paises}
                placeholder="Seleccione su país de origen ej: Colombia"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                autoComplete="chrome-off" 
                required
                isLoading={isLoadingpaises} 
                isDisabled={isLoadingpaises || errorpaises} 
                noOptionsMessage={() => 
                  errorpaises 
                    ? "Error al cargar los paises" 
                    : paises && paises.length === 0 
                      ? "No hay paises disponibles" 
                      : "No se encontraron resultados"
                }
              />
            </div>

            {/* Ciudad de origen */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Ciudad de origen (Si tu ciudad no aparece, avisanos para agregarla):
                <span className="text-red-500 ml-1">*</span>
              </label>
              
              <Select
                type= "hidden"
                name="ciudadOrigen"
                value={getOptionFromValue(ciudades, nuevoTutor.ciudadOrigen)}
                onChange={(option) => handleChange(null, { ...option, name: 'ciudadOrigen' })}
                options={ciudades}
                placeholder="Seleccione su ciudad de vivienda ej: Bucaramanga"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                autoComplete="none"
                required
                isLoading={isLoadingciudades} // Agregar estado de carga
                isDisabled={!nuevoTutor.paisOrigen}
              />
            </div>

            {/* Contraseña */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Contraseña:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="password"
                name="contrasena"
                value={nuevoTutor.contrasena}
                onChange={handleChange}
                placeholder="Ingrese una contraseña"
                className="p-2 border border-gray-300 rounded w-full"
                required
                autoComplete="new-password"
              />
              <div className="mt-2 text-sm">
                <p className="font-semibold">La contraseña debe cumplir:</p>
                <ul className="pl-5 list-disc">
                  <li className={nuevoTutor.contrasena.length >= 8 ? "text-green-600" : "text-gray-600"}>
                    Mínimo 8 caracteres
                  </li>
                  <li className={/\d/.test(nuevoTutor.contrasena) ? "text-green-600" : "text-gray-600"}>
                    Al menos un número
                  </li>
                  <li className={/[A-Z]/.test(nuevoTutor.contrasena) ? "text-green-600" : "text-gray-600"}>
                    Al menos una letra mayúscula
                  </li>
                  <li className={/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(nuevoTutor.contrasena) ? "text-green-600" : "text-gray-600"}>
                    Al menos un carácter especial (!@#$%^&*...)
                  </li>
                </ul>
              </div>
            </div>

            {/* Confirmar contraseña */}
            <div className="flex flex-col">
              <label className="mb-1 flex items-center">
                Confirmar contraseña:
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="password"
                name="confirmarContrasena"
                value={nuevoTutor.confirmarContrasena}
                onChange={handleChange}
                placeholder="Confirme su contraseña"
                className={`p-2 border ${
                  nuevoTutor.confirmarContrasena
                    ? nuevoTutor.contrasena === nuevoTutor.confirmarContrasena 
                      ? "border-green-500" 
                      : "border-red-500"
                    : "border-gray-300"
                } rounded w-full`}
                required
              />
              {nuevoTutor.confirmarContrasena && (
                nuevoTutor.contrasena === nuevoTutor.confirmarContrasena 
                  ? <p className="text-green-500 text-sm mt-1">Las contraseñas coinciden</p>
                  : <p className="text-red-500 text-sm mt-1">Las contraseñas no coinciden</p>
              )}
            </div>

            {/* Términos y condiciones */}
            <div className="flex items-center">
              <input
                type="checkbox"
                name="aceptoTerminos"
                checked={nuevoTutor.aceptoTerminos}
                onChange={handleChange}
                className="mr-2"
                required
              />
              <label>Acepto los términos y condiciones</label>
            </div>

            {/* Botón de envío */}
            <div className="flex justify-center mt-6">
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-8 rounded-full transition-colors duration-300"
              >
                Enviar
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Formulario;